import {useState, useEffect, useRef} from "react";

const HoverInfoCard = ({ info, additionalInfo, position = "pos-overlay", custom=false, backgroundColor, shouldDisplayIcon = (callback) => callback(true), displayOnClick=false }) => {
    const wrapperRef = useRef(null);
    const [hovered, setHovered] = useState(false);
    const [pinned, setPinned] = useState(false);
    const [shouldDisplay, setShouldDisplay] = useState(false);

    // Call shouldDisplayIcon callback to determine if icon should be displayed
    useEffect(() => {
        shouldDisplayIcon((show) => {
            setShouldDisplay(show);
        });
    }, [shouldDisplayIcon]);

    useEffect(() => {
        if (!displayOnClick) {
            return;
        }

        const handleDocumentClick = (event) => {
            if (wrapperRef.current && wrapperRef.current.contains(event.target)) {
                return;
            }
            setPinned(false);
        };

        document.addEventListener('click', handleDocumentClick, true);

        return () => {
            document.removeEventListener('click', handleDocumentClick, true);
        };
    }, [displayOnClick]);

    useEffect(() => {
        if (!displayOnClick) {
            setPinned(false);
        }
    }, [displayOnClick]);

    // Return null if should not display
    if (!shouldDisplay) {
        return null;
    }

    // Parse position to separate position and no-max classes
    const positionClasses = position.split(' ');
    const positionClass = positionClasses.find(cls => cls.startsWith('pos-')) || 'pos-overlay';
    const hasNoMax = positionClasses.includes('no-max');
    const wrapperClass = `hover-info-wrapper ${positionClass}${hasNoMax ? ' no-max' : ''}`;
    const isPopoverVisible = displayOnClick ? (hovered || pinned) : hovered;
    const popoverClass = `${custom ? 'custom-popover' : 'info-popover'} ${isPopoverVisible ? 'visible' : ''}${hasNoMax ? ' no-max' : ''}`;

    // Determine background color style
    const getBackgroundStyle = () => {
        if (!backgroundColor) {
            return {}; // Use default CSS background
        }
        if (backgroundColor === 'transparent') {
            return { backgroundColor: 'transparent' };
        }
        if (backgroundColor === 'white' || backgroundColor === '#fff' || backgroundColor === '#ffffff') {
            return { backgroundColor: '#ffffff', color: '#000' };
        }
        return { backgroundColor };
    };

    const backgroundStyle = !custom ? getBackgroundStyle() : {};

    return (
        <div
            ref={wrapperRef}
            className={wrapperClass}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {
                info && (
                    <>
                        <div
                            className="hover-info-static"
                            onClick={displayOnClick ? () => {
                                setPinned((prev) => !prev);
                            } : undefined}
                        >
                            {info}
                        </div>
                        {
                            <div className={popoverClass} style={backgroundStyle}>
                                {additionalInfo ?? info}
                            </div>
                        }
                    </>
                )
            }
        </div>
    );
}

export default HoverInfoCard;
